import axios from 'axios';
import { authService } from './authService';
import { errorLogService } from './errorLogService';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

// Criar instância do Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor de request - adiciona token JWT apenas se válido
api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    
    // Validar se o token existe e não está expirado
    if (token && authService.isTokenValid()) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (token) {
      // Token existe mas está expirado - redirecionar para login
      console.warn('[API] Token expirado, redirecionando para login...');
      const currentPath = window.location.pathname + window.location.search;
      authService.removeToken();
      authService.redirectToLogin(currentPath);
      // Abortar requisição
      return Promise.reject(new Error('Token expirado'));
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de response - trata erros 401 e loga erros HTTP
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // NÃO logar erros para /console/errors (evita loop infinito)
    if (!error.config?.url?.includes('/console/errors')) {
      const errorMsg = error.message || 'Network error';
      const statusText = error.response?.statusText ? ` (${error.response.statusText})` : '';
      const fullError = `HTTP ${error.response?.status || 'Error'}${statusText}: ${errorMsg}`;

      // Extrair contexto detalhado da requisição para facilitar diagnóstico
      const requestData = error.config?.data;
      let requestPayload;
      try {
        requestPayload = typeof requestData === 'string' ? JSON.parse(requestData) : requestData;
      } catch {
        requestPayload = requestData;
      }
      const apiContext = {
        method: error.config?.method?.toUpperCase(),
        requestUrl: error.config?.url,
        requestPayload,
        responseStatus: error.response?.status,
        responseData: error.response?.data,
      };

      errorLogService.logError(fullError, error.config?.url, apiContext).catch(() => {});
    }

    if (error.response?.status === 401) {
      // Token inválido ou expirado - salva path atual para retornar após login
      const currentPath = window.location.pathname + window.location.search;
      authService.redirectToLogin(currentPath);
    }
    return Promise.reject(error);
  }
);

export default api;
